import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import './MessaggioChiusura.scss';

class MessaggioChiusura extends Component {
  render() {
    const { type, messaggiFerie, primaryColor } = this.props;

    if (
      moment().isAfter(moment(messaggiFerie.dal)) &&
      moment().isBefore(moment(messaggiFerie.al))
    ) {
      if (type === 'checkout') {
        return (
          <div className="messaggio-chiusura">
            {messaggiFerie.checkoutRiga1}
            {!!messaggiFerie.checkoutRiga2 && (
              <span>
                <br />
                {messaggiFerie.checkoutRiga2}
              </span>
            )}
            {!!messaggiFerie.checkoutRiga3 && (
              <span>
                <br />
                {messaggiFerie.checkoutRiga3}
              </span>
            )}
          </div>
        );
      } else {
        return (
          <div
            className="messaggio-chiusura cart"
            style={{ color: primaryColor }}
          >
            <span
              dangerouslySetInnerHTML={{ __html: messaggiFerie.cartRiga1 }}
            />
            {!!messaggiFerie.cartRiga2 && (
              <span>
                <br />
                <span
                  dangerouslySetInnerHTML={{ __html: messaggiFerie.cartRiga2 }}
                />
              </span>
            )}
            {!!messaggiFerie.cartRiga3 && (
              <span>
                <br />
                <span
                  dangerouslySetInnerHTML={{ __html: messaggiFerie.cartRiga3 }}
                />
              </span>
            )}
          </div>
        );
      }
    }

    return null;
  }
}

const mapStateToProps = state => ({
  messaggiFerie: state.store.data.messaggiFerie,
  primaryColor: state.store.data.loghiTemplate.brandColor,
});

export default connect(mapStateToProps)(MessaggioChiusura);
